// The tour launchers' tiny shared surface, kept apart from the engine so the
// Demo Gallery can import it without pulling the whole library into its chunk.

/** Fired by the Demo Gallery's launchers; the mounted library opens the tour. */
export const DEMO_TOUR_START_EVENT = "clank:demo-tour-start";

/** The Demo Gallery's side of the launchers: names which journey to open. */
export const startDemoTour = (tourId: string) => {
  window.dispatchEvent(new CustomEvent(DEMO_TOUR_START_EVENT, { detail: tourId }));
};
